export default {
  namespaced: true,
  proxy_rtsp_server: {
    title: "proxy rtsp server | proxy rtsp servers",
    name: "name",
    api_host: "api host",
    rtsp_host: "RTSP host",
    playback_host: "playback host",
    hls_host: "HLS host",
    webrtc_host: "webrtc host",
    log_level: "Log Level",
    log_destinations: "Log Destinations",
    log_file: "Log File",
    sys_log_prefix: "Syslog Prefix",
    read_timeout: "Read Timeout",
    write_timeout: "Write Timeout",
    write_queue_size: "Write Queue Size",
    udp_max_payload_size: "UDP Max Payload Size",
    run_on_connect: "Run On Connect",
    run_on_connect_restart: "Run On Connect Restart",
    run_on_disconnect: "Run On Disconnect",
    auth_method: "Authentication Method",
    auth_internal_users: "Internal Users",
    auth_http: "HTTP Auth",
    auth_http_address: "HTTP Auth Address",
    auth_http_exclude: "HTTP Auth Exclude",
    auth_jwt_jwks: "JWT JWKS",
    auth_jwt_jwks_fingerprint: "JWT JWKS Fingerprint",
    auth_jwt_claim_key: "JWT Claim Key",
    auth_jwt_exclude: "JWT Exclude",
    auth_jwt_in_http_query: "JWT In HTTP Query",
    enable_api: "Enable API",
    api_address: "API Address",
    enable_api_encryption: "Enable API Encryption",
    api_server_key: "API Server Key",
    api_server_cert: "API Server Certificate",
    api_allow_origin: "API Allow Origin",
    api_trusted_proxies: "API Trusted Proxies",
    enable_metrics: "Enable Metrics",
    metrics_address: "Metrics Address",
    enable_metrics_encryption: "Enable Metrics Encryption",
    metrics_server_key: "Metrics Server Key",
    metrics_server_cert: "Metrics Server Certificate",
    metrics_allow_origin: "Metrics Allow Origin",
    metrics_trusted_proxies: "Metrics Trusted Proxies",
    enable_pprof: "Enable Pprof",
    pprof_address: "Pprof Address",
    enable_pprof_encryption: "Enable Pprof Encryption",
    pprof_server_key: "Pprof Server Key",
    pprof_server_cert: "Pprof Server Certificate",
    pprof_allow_origin: "Pprof Allow Origin",
    pprof_trusted_proxies: "Pprof Trusted Proxies",
    enable_playback: "Enable Playback",
    playback_address: "Playback Address",
    enable_playback_encryption: "Enable Playback Encryption",
    playback_server_key: "Playback Server Key",
    playback_server_cert: "Playback Server Certificate",
    playback_allow_origin: "Playback Allow Origin",
    playback_trusted_proxies: "Playback Trusted Proxies",
    enable_rtsp: "Enable RTSP",
    rtsp_transports: "RTSP Transports",
    rtsp_encryption: "RTSP Encryption",
    rtsp_address: "RTSP Address",
    rtsps_address: "RTSPS Address",
    rtp_address: "RTP Address",
    rtcp_address: "RTCP Address",
    multicast_ip_range: "Multicast IP Range",
    multicast_rtp_port: "Multicast RTP Port",
    multicast_rtcp_port: "Multicast RTCP Port",
    rtsp_server_key: "RTSP Server Key",
    rtsp_server_cert: "RTSP Server Certificate",
    rtsp_auth_methods: "RTSP Auth Methods",
    enable_rtmp: "Enable RTMP",
    rtmp_address: "RTMP Address",
    rtmp_encryption: "RTMP Encryption",
    rtmps_address: "RTMPS Address",
    rtmp_server_key: "RTMP Server Key",
    rtmp_server_cert: "RTMP Server Certificate",
    enable_hls: "Enable HLS",
    hls_address: "HLS Address",
    enable_hls_encryption: "Enable HLS Encryption",
    hls_server_key: "HLS Server Key",
    hls_server_cert: "HLS Server Certificate",
    hls_allow_origin: "HLS Allow Origin",
    hls_trusted_proxies: "HLS Trusted Proxies",
    hls_always_remux: "HLS Always Remux",
    hls_variant: "HLS Variant",
    hls_segment_count: "HLS Segment Count",
    hls_segment_duration: "HLS Segment Duration",
    hls_part_duration: "HLS Part Duration",
    hls_segment_max_size: "HLS Segment Max Size",
    hls_directory: "HLS Directory",
    hls_muxer_close_after: "HLS Muxer Close After",
    enable_webrtc: "Enable WebRTC",
    webrtc_address: "WebRTC Address",
    enable_webrtc_encryption: "Enable WebRTC Encryption",
    webrtc_server_key: "WebRTC Server Key",
    webrtc_server_cert: "WebRTC Server Certificate",
    webrtc_allow_origin: "WebRTC Allow Origin",
    webrtc_trusted_proxies: "WebRTC Trusted Proxies",
    webrtc_local_udp_address: "WebRTC Local UDP Address",
    webrtc_local_tcp_address: "WebRTC Local TCP Address",
    webrtc_ips_from_interfaces: "WebRTC IPs From Interfaces",
    webrtc_ips_from_interfaces_list: "WebRTC IPs From Interfaces List",
    webrtc_additional_hosts: "WebRTC Additional Hosts",
    webrtc_ice_servers_2: "WebRTC ICE Servers 2",
    webrtc_handshake_timeout: "WebRTC Handshake Timeout",
    webrtc_track_gather_timeout: "WebRTC Track Gather Timeout",
    webrtc_stun_gather_timeout: "WebRTC STUN Gather Timeout",
    enable_srt: "Enable SRT",
    srt_address: "SRT Address",
    api_settings: "API Settings",
    authentication: "Authentication",
    password_not_required_for_user_any: "Password not required for user 'any'"
  },
};
